<app-page-header></app-page-header>
<app-breadcromb pageName="File Upload"></app-breadcromb>
<!-- Candidate Dashboard Area Start -->
<section class="candidate-dashboard-area section_70">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-12 dashboard-left-border">
                <div class="dashboard-left">
                    <app-client-dashboard-sidebar></app-client-dashboard-sidebar>
                </div>
            </div>
            <div class="col-lg-9 col-md-12">
                <div class="dashboard-right">
                    <div class="candidate-profile">
                        <div class="candidate-single-profile-info">
                            <form [formGroup]="uploadFileForm" (ngSubmit)="uploadFile()">
                                <div class="resume-box">
                                    <h3>Add educational certificate </h3>
                                    <div class="row">
                                        <div class="col-md-4>">
                                            <div class="single-input">
                                                <label>Education Type:</label><span class="ng-star-inserted"> *</span>
                                                <select required formControlName="educationType">
                          <option  value="O'Level">O'Level</option>
                          <option  value="A'Level">A'Level</option>
                          <option *ngFor="let educationType of educationTypes"
                                  value="{{educationType.name}}">{{educationType.name}}</option>
                        </select>
                                                <div *ngIf="f.educationType.touched && f.educationType.invalid" class="error">
                                                    <span *ngIf="f.educationType.errors.required" style="color: red !important;">Education type is required</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label>File Name:</label><span class="ng-star-inserted"> *</span>
                                                <input formControlName="name" id="name" type="text" maxlength="254" class="form-control">
                                                <div *ngIf="f.name.touched && f.name.invalid" class="text-danger">
                                                    <span *ngIf="f.name.errors.required">File name is required</span>
                                                    <span *ngIf="f.name.errors.minlength">Name should be at least 3 characters</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label>Pick a document (Max 3MB):</label><span class="ng-star-inserted"> *</span>
                                                <input formControlName="file" id="file" type="file" class="form-control" (change)="onFileChange($event)">
                                                <div *ngIf="f.file.touched && f.fileSource.invalid" class="text-danger">
                                                    <span *ngIf="f.fileSource.errors.required">File is required.</span>
                                                </div>
                                                <div *ngIf="maxFileSizeReached" class="text-danger">
                                                    <span>Your file size should be less than 3MB</span>
                                                </div>
                                                <div *ngIf="!pdfPicked" class="text-danger">
                                                    <span>Selected file format is not supported, pick PDF</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="submit-resume">
                                    <button class="btn btn-success" [disabled]="uploadFileForm.invalid || !pdfPicked || maxFileSizeReached">
                    <span *ngIf="!uploading">Save PDF File</span>
                    <span *ngIf="uploading">Uploading.....</span>
                  </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Candidate Dashboard Area End -->